import React from "react"
import { useTranslation } from "react-i18next"
import Spinner from "../common/Spinner"
import Toolbar from "./Toolbar"
import ToolbarItem from "./ToolbarItem"
import { Badge, Button } from "@mui/material"

interface AiEffectToolbarProps {
  remainingRegenerations: number
  isProcessing: boolean
  onRegenerate: () => void
  imageUrls: string[]
  selectedIndex: number
  onSelect: (index: number) => void
}

export default function AiEffectToolbar({
  remainingRegenerations,
  isProcessing,
  onRegenerate,
  imageUrls,
  selectedIndex,
  onSelect,
}: AiEffectToolbarProps) {
  const { t } = useTranslation()
  return (
    <Toolbar>
      {imageUrls.map((url, index) => (
        <ToolbarItem
          key={index}
          selected={index === selectedIndex}
          onClick={() => onSelect(index)}
        >
          <img
            crossOrigin="anonymous"
            src={url}
            alt={"AI Effect " + (index + 1)}
          />
        </ToolbarItem>
      ))}
      {isProcessing ? (
        <div style={{ transform: "scale(0.5)" }}>
          <Spinner color="#333" />
        </div>
      ) : (
        remainingRegenerations >= 1 && (
          <Badge
            color="secondary"
            badgeContent={remainingRegenerations}
          >
            <Button
              variant="outlined"
              color="secondary"
              onClick={onRegenerate}
              style={{ color: "#333" }}
            >
              {t("edit.aiEffect.regenerate")}
            </Button>
          </Badge>
        )
      )}
    </Toolbar>
  )
}
